import React, { useContext, useEffect, useReducer, useMemo } from 'react';
import { lockedReducer } from '../Utils/reducers';
import { Box, IconButton, Tooltip, TextField } from '@mui/material';
import toast from 'react-hot-toast'
import { api } from '../../services/api';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Table, { TableHook } from '../Table';
import { externalComponent } from '../AppRoutes';
import { getSession } from '../../contexts/auth';
import ConfirmationDialog from '../Utils/ConfirmationDialog';
import EditCredenciado from './edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import QrCodeIcon from '@mui/icons-material/QrCode';
import QRCode from 'qrcode';
import ColorButton from '../Buttons/ColorButton';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


const url = '/credenciado/'

const getCredenciados = async (setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url)
    if (res.status === 200) {
        setState({ rows: res.data, rowsReset: res.data })
    }
    setLoader(false)
}

const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 200) {
        toast.success('Deletado com sucesso')
        setState({ deleteRow: null })
        getData()
        return
    } else {
        toast.error(res.data.detail)
    }

}

const formatDate = (isoDate) => {
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
};

const generateAndDownloadQRCode = async (inputText, fileName) => {
    const qrSize = 600;  // Tamanho do QR Code
    const textHeight = 60; // Altura reservada para o texto (aumentado um pouco)
    const fontSize = 60; // Tamanho da fonte aumentado

    // Criar um canvas separado para o QR Code
    const qrCanvas = document.createElement('canvas');
    await QRCode.toCanvas(qrCanvas, inputText, { width: qrSize });

    // Criar um novo canvas para conter o QR Code + texto
    const canvas = document.createElement('canvas');
    canvas.width = qrSize;
    canvas.height = qrSize + textHeight;
    const ctx = canvas.getContext('2d');

    // Desenhar fundo branco
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Desenhar o QR Code no novo canvas
    ctx.drawImage(qrCanvas, 0, 0);

    // Configurar o texto abaixo do QR Code
    ctx.font = `bold ${fontSize}px Arial`; // Adicionando 'bold'
    ctx.textAlign = 'center';
    ctx.fillStyle = 'black';

    // Definir a posição do texto (centralizado abaixo do QR Code)
    ctx.fillText(fileName, qrSize / 2, qrSize + (textHeight / 2) - 10); // Ajuste fino na posição do texto

    // Criar URL da imagem
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');

    // Criar link de download
    let downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `${fileName}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};

const columns = (setState) => {
    return [
        { field: 'cartao', headerName: 'Cartão', flex: 1, filterType: 'string' },
        { field: 'nome', headerName: 'Nome', flex: 1, filterType: 'string' },
        {
            field: 'validadeinicial', headerName: 'Validade Inicial', flex: 1, filterType: 'string',
            renderCell: ({ value }) => (
                formatDate(value)
            )
        },
        {
            field: 'validadefinal', headerName: 'Validade Final', flex: 1, filterType: 'string',
            renderCell: ({ value }) => (
                formatDate(value)
            )
        },
        { field: 'nome_acesso', headerName: 'Acesso', flex: 1, filterType: 'string' },
        {
            field: 'valido', headerName: 'Ativo', flex: 1, filterType: 'string',
            renderCell: ({ value }) => (
                <>
                    {value === 'T' ?
                        <CheckCircleIcon sx={{ color: 'green' }} />
                        :
                        <HighlightOffIcon sx={{ color: 'red' }} />
                    }
                </>
            )
        },
        {
            field: 'dentro', headerName: 'Dentro', flex: 1, filterType: 'string',
            renderCell: ({ value }) => (
                <>
                    {value === 'T' ?
                        <CheckCircleIcon sx={{ color: 'green' }} />
                        :
                        <HighlightOffIcon sx={{ color: 'red' }} />
                    }
                </>
            )
        },
        {
            field: 'facility', headerName: 'Facility', flex: 1, filterType: 'string',
            renderCell: ({ value }) => (
                <>
                    {value === 'T' ?
                        <CheckCircleIcon sx={{ color: 'green' }} />
                        :
                        <HighlightOffIcon sx={{ color: 'red' }} />
                    }
                </>
            )
        },
        {
            field: 'chuveiro', headerName: 'Chuveiro', flex: 1, filterType: 'string',
            renderCell: ({ value }) => (
                <>
                    {value === 'T' ?
                        <CheckCircleIcon sx={{ color: 'green' }} />
                        :
                        <HighlightOffIcon sx={{ color: 'red' }} />
                    }
                </>
            )
        },
        {
            field: 'actions', headerName: 'Ações', filterable: false, flex: 1,
            renderCell: (props) => {
                return (
                    <Box >
                        {
                            <Tooltip title='Edita credenciado'>
                                <IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton>
                            </Tooltip>
                        }
                        {
                            <Tooltip title='Deleta credenciado'>
                                <IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton>
                            </Tooltip>
                        }
                        {
                            <Tooltip title='Download QRCODE'>
                                <IconButton onClick={() => generateAndDownloadQRCode(props.row.cartao, props.row.nome)}><QrCodeIcon /></IconButton>
                            </Tooltip>
                        }
                    </Box>
                )
            }
        }
    ]
}

const filter = (state, setState) => {
    console.log(state.rows)
    const newRows = state.rowsReset.filter(each => {
        const cartaoMatch =
            !state.cartaoFilter || each.cartao.toString() === state.cartaoFilter.toString();

        const nomeMatch =
            !state.nomeFilter ||
            each.nome.toLowerCase().includes(state.nomeFilter.toLowerCase());

        const chuveiroMatch =
            !state.selectedChuveiro || each.chuveiro.toString() === state.selectedChuveiro.toString();

        return cartaoMatch && nomeMatch && chuveiroMatch;
    });
    setState({ rows: newRows })
}

const clearFilter = (state, setState) => {
    setState({ rows: state.rowsReset, cartaoFilter: '', nomeFilter: '', selectedChuveiro: '' })
}

const selectChuveiro = {
    "T": {
        "nome": "Ativado",
        "id": "T",
    },
    "F": {
        "nome": "Desativado",
        "id": "F",
    }
}


const Credenciados = () => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        rowsReset: [],
        editRow: null,
        deleteRow: null,
        qrcodeRow: null,
        cartaoFilter: '',
        nomeFilter: '',
        selectedChuveiro: ''
    })

    const user = getSession()

    const [table, reloadTable] = TableHook()

    const reloadData = () => {
        getCredenciados(setState, setLoader)
    }

    useEffect(() => {
        getCredenciados(setState, setLoader)
    }, [setLoader])

    return (
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o credenciado ${state.deleteRow.nome} - ${state.deleteRow.cartao}?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }

            {state.editRow &&
                <EditCredenciado
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                />
            }

            <Box className='information-table nfsentrada-mainframe'>

                <Box className='nfsentrada-filters'>
                    <Box className='filter-items'>


                        <Box className='item-profile-row'>

                            <TextField
                                id="cartaoFilter"
                                type="text"
                                label="Cartão"
                                value={state.cartaoFilter}
                                onChange={(e) => { setState({ 'cartaoFilter': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 20
                                }}
                            />

                        </Box>

                        <Box className='item-profile-row'>

                            <TextField
                                id="nomeFilter"
                                type="text"
                                label="Nome"
                                value={state.nomeFilter}
                                onChange={(e) => { setState({ 'nomeFilter': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 20
                                }}
                            />

                        </Box>

                        <Box className='item-profile-row' sx={{ width: '8rem' }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Chuveiro</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Chuveiro"
                                    value={state.selectedChuveiro}
                                    onChange={(e) => setState({ 'selectedChuveiro': e.target.value })}
                                >

                                    {
                                        Object.entries(selectChuveiro).map(([key, value]) => (
                                            <MenuItem key={key} value={value.id}>{value.nome}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Box>


                    </Box>
                    <Box className='filter-buttons'>
                        <ColorButton onClick={() => filter(state, setState, reloadTable)}>Localizar</ColorButton>
                        <ColorButton onClick={() => clearFilter(state, setState)}>Limpar filtros</ColorButton>
                    </Box>
                </Box>

                <Box className='user-table' sx={{ backgroundColor: '#ffffff' }}>
                    <Table
                        rows={state.rows}
                        columns={useMemo(() => columns(setState))}
                        pagination
                        density='compact'
                        pageSize={25}
                        toolbar
                        slots={{
                            addComponent: () => setState({ editRow: {} }),
                            csvComponent: true
                        }}
                        getURL={url}
                        updateRows={(rows) => setState({ 'rows': rows })}
                        innerRef={table}
                        hideFooter
                    />
                </Box>
            </Box>
        </>
    )
}

export default Credenciados;